
import { sortBy, uniqBy, countBy } from "lodash";
import {
  getAcceptabilityFromProCon,
  getSubOptionById,
  getCriterionById,
  getAimById,
  normalizeByAlternative,
  filterItemsBy,
  c_alternativesIds,
  getAimsCountFromAimsAndCriterion,
  getAimsFromItems,
  state,
  getStakeholderName,
} from "@/store";
import { NormalizedArgument } from "@/@types";

import Acceptability from "@/components/Acceptability.vue";
import PropertiesListCriterion from "@/components/PropertiesList/PropertiesListCriterion.vue";
import { computed, defineComponent, toRefs, PropType } from "vue";
export default defineComponent({
  props: {
    items: {
      type: Array as PropType<NormalizedArgument[]>,
      required: true,
    },
    property: {
      type: String,
    },
  },

  setup(props) {
    const { items, property } = toRefs(props);

    const stakeholderItems = computed(() => {
      return uniqBy(items.value, "stakeholder");
    });

    const criterionItems = computed(() => {
      return uniqBy(items.value, "criterion");
    });

    const aimItems = computed(() => {
      return uniqBy(items.value, "aim");
    });

    return {
      state,

      c_alternativesIds,

      stakeholderItems,
      criterionItems,
      aimItems,

      hasMany: computed(() => {
        return criterionItems.value.length > 1 || aimItems.value.length > 1;
      }),

      getStakeholderName,
      getAimsCountFromAimsAndCriterion,
      getAimsFromItems,
      countBy,
      sortBy,
      getSubOptionById,
      getCriterionById,
      getAimById,
      getAcceptabilityFromProCon,
      normalizeByAlternative,
      filterItemsBy,
      uniqBy,
    };
  },

  // data: () => ({
  //   state,
  //   showDetails: false
  // }),
  // computed: {

  // },
  components: {
    Acceptability,
  },
  // props: ["items", "property"],
  // methods: {

  // }
});
